/**
 * resolveLabel
 *
 * Traduce un valor crudo persistido a su etiqueta de presentación. Ante un
 * valor desconocido devuelve el crudo en vez de un placeholder: es lo que
 * mantiene abiertos los catálogos (un tipo de artículo nuevo, un estado nuevo)
 * sin romper reportes ni exports.
 */
export function resolveLabel(
  labels: Record<string, string>,
  value: string | null | undefined,
  fallback = '-'
): string {
  if (typeof value !== 'string' || value.length === 0) {
    return fallback;
  }
  return labels[value] ?? value;
}
